import { Model } from 'modules/core/lib/mobx-rest'

interface IQualificationEntry {
  [key: string]: unknown
}

class QualificationEntry extends Model<IQualificationEntry> {
  static Campaigns = {
    contactSalesApp: 'contact-sales-app',
    requestPayrollDemo: 'payroll-demo',
    expensesWalletAccount: 'expenses-wallet-account',
    createAccount: 'create-account',
    createPolicy: 'create-policy',
    createPhysicalCard: 'create-physical-card',
    createVirtualCard: 'create-virtual-card',
    wantsToChurn: 'churn',
    contactCx: 'contact_cx',
    callPage: 'inbound contact sales - freemium',
  }

  static TargetTeams = {
    sales: 'sales',
    customerExperience: 'cx',
    expenses: 'expenses',
  }

  static CxCampaigns = {
    requestInformationPayrollIncidences: 'request_module_information_payroll_incidences',
    requestUpdateShiftManagement: 'update-shift-management',
  }

  static urlRoot() {
    return '/internal/api_qualification_entries'
  }
}

export default QualificationEntry
